import { render, staticRenderFns } from "./HotelTransferList.vue?vue&type=template&id=2d47ef26&"
import script from "./HotelTransferList.vue?vue&type=script&lang=js&"
export * from "./HotelTransferList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports